"use client";

import { usePublicClient } from "wagmi";
import { ethers, JsonRpcProvider } from "ethers";
import { useMemo } from "react";

export default function useEthersProvider() {
  const publicClient = usePublicClient();

  // Memoize the provider instance
  const provider = useMemo(() => {
    if (publicClient) {
      return new ethers.providers.JsonRpcProvider(publicClient.transport.url);
    }
    return null;
  }, [publicClient]);

  return provider;
}
